// extracted by mini-css-extract-plugin
export var defaultWrapper = "_nw-3";
export var downloadButton = "_nw-4";
export var fileContainer = "_nw-9 _nw-7";
export var fileContainerBase = "_nw-7";
export var fileContainerFixedHeight = "_nw-8 _nw-7";
export var fileInfo = "_nw-5";
export var fileInfoWidthRestricted = "_nw-6";
export var fileType = "_nw-1";
export var fileTypeName = "_nw-2";
export var image = "_nw-0";
export var link = "_nw-b";
export var overflowEllipsis = "_nw-a";